import {isCell} from '@packages/utilities/elementTypeUtils';
import {getChildren} from '@packages/utilities/platform';
import {type ExpressionElement} from '@packages/systems/wfdl-ast';

/**
 * Checks if the selected cell is empty
 */
const isQuickStackCellEmpty = (selectedElement: ExpressionElement): boolean => {
  if (isCell(selectedElement)) {
    const cellChildren = getChildren(selectedElement);
    if (!cellChildren) return false;
    return cellChildren.length === 0;
  }
  // If the selected element is not a cell, just return false
  return false;
};

export default isQuickStackCellEmpty;
